import { CustomDateTimePicker, CustomDateTimePickerProps } from '@lfg/ui/components';
import { Box, Typography } from '@mui/material';

import { colors } from 'src/global/styles/colors';

export interface AdminDateTimePickerProps<T extends Date> extends CustomDateTimePickerProps<T> {
  isError?: boolean;
  errorMsg?: string;
  isHideHint?: boolean;
}

export function AdminDateTimePicker(props: AdminDateTimePickerProps<Date>) {
  const { sx, isError, errorMsg, isHideHint = false, ...rest } = props;
  return (
    <Box>
      <CustomDateTimePicker
        disablePast
        sx={{
          width: '100%',
          '& .MuiOutlinedInput-root': {
            color: 'white',
            '& fieldset': {
              borderColor: `${isError ? colors.error : colors.neutral015} !important`,
            },
            '&:hover fieldset': {
              borderColor: 'white !important',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'white',
            },
            '&.Mui-error .MuiOutlinedInput-notchedOutline': {
              borderColor: colors.neutral015,
            },
          },
          '& .MuiInputLabel-root': {
            color: 'white',
          },
          '& .MuiSvgIcon-root': {
            color: 'white',
          },
          '& .MuiInputBase-input.Mui-readOnly': {
            cursor: 'not-allowed',
          },
          ...sx,
        }}
        {...rest}
      />
      {isHideHint ? null : (
        <Typography paddingTop={0.5} color={colors.neutral300} fontSize={'12px'} fontStyle={'italic'}>
          * Time displayed in your current time zone
        </Typography>
      )}
      {isError ? (
        <Typography paddingTop={1} color={colors.error} fontSize={'14px'}>
          {errorMsg}
        </Typography>
      ) : null}
    </Box>
  );
}
